import React, { useState } from 'react';
import Modal from '@ui-components/Modal';

interface ReportAnomalyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (anomalyDescription: string) => void;
  isReporting: boolean;
  gameInfo?: string;
}

export const ReportAnomalyModal: React.FC<ReportAnomalyModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isReporting,
  gameInfo
}) => {
  const [anomalyDescription, setAnomalyDescription] = useState('');

  const handleConfirm = () => {
    if (anomalyDescription.trim()) {
      onConfirm(anomalyDescription.trim());
      setAnomalyDescription('');
    }
  };

  const handleClose = () => {
    setAnomalyDescription('');
    onClose();
  };

  return (
    <Modal
      title="Segnala Anomalia Referto"
      opened={isOpen}
      onExit={handleClose}
      maxWidth="w-full sm:max-w-lg"
    >
      <div className="space-y-4">
        {gameInfo && (
          <p className="text-sm text-gray-600 font-medium">Gara: {gameInfo}</p>
        )}
        <p className="text-sm text-gray-700">
          Indica cosa non va nel referto caricato. L'arbitro riceverà una email con la tua segnalazione e dovrà ricaricare il documento.
        </p>
        
        <div>
          <label htmlFor="anomaly-description" className="block text-sm font-medium text-gray-700 mb-2">
            Descrizione anomalia *
          </label>
          <textarea
            id="anomaly-description"
            rows={4}
            value={anomalyDescription}
            onChange={(e) => setAnomalyDescription(e.target.value)}
            disabled={isReporting}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:bg-gray-50"
            placeholder="Es: Il referto è illeggibile, mancano le firme, formato non corretto..."
          />
        </div>
        
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={handleClose}
            disabled={isReporting}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annulla
          </button>
          <button
            onClick={handleConfirm}
            disabled={isReporting || !anomalyDescription.trim()}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isReporting ? (
              <>
                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Invio...
              </>
            ) : (
              'Invia Segnalazione'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
